// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2ShJK","footer":"ModalInfo_footer__2fAz2"};